/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {logInfo} from "App/debug";
import TextureDataHandler from "App/utils/textures/texture_data_handler";

export default
class ImageDataLoadersFactory {

    private static registeredClasses: any = {};

    public static register(aClass: any) {
        ImageDataLoadersFactory.registeredClasses[aClass.TypeName] = aClass;
    }

    public static create (aTypeName: string, aTextureDataHandler: TextureDataHandler, aDiffuseTextureProperties: any, aLevel?: number) {
        let registeredClass = ImageDataLoadersFactory.registeredClasses[aTypeName];
        if (registeredClass === undefined) {
            logInfo("Error: ImageDataLoadersFactory.create on undefined type " + aTypeName);
        }

        let instance = registeredClass.create(aTextureDataHandler, aDiffuseTextureProperties, aLevel === undefined ? "0" : aLevel);
        instance._typeName = aTypeName;
        return instance;
    }
}
